/* Mega menu "Znajdz swoje auto": przelaczanie paneli marek w sidebarze.
   Panele sa wyrenderowane w Liquid; tu tylko atrybuty aria + data-gp-active.
   Bez tego pliku (brak JS albo blad ladowania) CSS pokazuje wszystkie panele pod soba. */
(() => {
  // Klasa gotowosci: CSS chowa nieaktywne panele dopiero, gdy ten plik naprawde wstal
  // (nie na samo html.js) - gdy skrypt nie dojdzie, widac wszystkie panele pod soba.
  document.documentElement.classList.add("gp-car-menu-active");

  // Blokada przewijania strony na czas otwartego mega menu. Bez niej scroll pod otwartym
  // menu zmniejsza logo w sticky headerze (ustawienie "reduce-logo-size") i menu skacze
  // razem z nim. Przewijanie listy marek i kafelkow dziala dalej - to overflow w srodku menu.
  const LOCK_CLASS = 'gp-car-menu-lock';
  const OPEN_SELECTOR = 'details.gp-car-menu:not(.gp-car-menu--drawer)[open]';
  // Druga klasa, szersza od blokady przewijania: obejmuje takze szuflade mobilna. Wisza na niej
  // reguly chowajace cudze widzety przyklejone do okna (patrz gp-car-menu.css) - te maja
  // z-index bliski maksimum i zaslanialy dol listy marek, czyli ostatnie alfabetycznie
  // zakladki (Volkswagen, Volvo). Blokady przewijania nie ruszamy, bo tam drawer ma wlasna.
  const OPEN_CLASS = 'gp-car-menu-open';
  const ANY_OPEN_SELECTOR = 'details.gp-car-menu[open]';
  let lockTimer = null;

  function syncScrollLock() {
    document.body.classList.toggle(OPEN_CLASS, !!document.querySelector(ANY_OPEN_SELECTOR));
    const open = !!document.querySelector(OPEN_SELECTOR);
    if (open === document.body.classList.contains(LOCK_CLASS)) return;
    if (open) {
      // Szerokosc zdjetego paska przewijania oddajemy jako padding, inaczej strona
      // przeskakuje w bok w chwili otwarcia menu.
      const gap = window.innerWidth - document.documentElement.clientWidth;
      if (Number.isFinite(gap) && gap > 0) {
        document.documentElement.style.setProperty('--gp-scrollbar-w', `${gap}px`);
      }
    }
    document.body.classList.toggle(LOCK_CLASS, open);
  }

  // Wysokosc panelu liczymy od DOLU naglowka, mierzonego w chwili otwarcia. Dawn ustawia
  // `--header-bottom-position-desktop` tylko raz (details-disclosure.js wychodzi, gdy zmienna
  // juz jest), wiec po przewinieciu strony - gdy pasek zapowiedzi zjedzie, a logo sie zmniejszy -
  // ta wartosc jest za duza i menu przestaje siegac dolu ekranu.
  function syncMenuTop() {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const bottom = Math.round(header.getBoundingClientRect().bottom);
    if (Number.isFinite(bottom) && bottom >= 0) {
      document.documentElement.style.setProperty('--gp-car-menu-top', `${bottom}px`);
    }
  }

  // Przelaczenie miedzy dwoma mega menu to zamkniecie jednego i otwarcie drugiego w tym
  // samym ticku - bez odroczenia blokada zdazylaby zniknac i wrocic (widoczny przeskok).
  function scheduleScrollLock() {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(syncScrollLock, 0);
  }

  class GpCarMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gpReady) return;
      this.dataset.gpReady = '1';
      this.tabs = [...this.querySelectorAll('[role="tab"][data-gp-tab]')];
      this.panels = new Map([...this.querySelectorAll('[data-gp-panel]')].map((p) => [p.dataset.gpPanel, p]));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.gpTab, { focus: true }));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, tab));
      });

      const details = this.closest('details');
      if (details) {
        details.addEventListener('toggle', () => {
          // hasAttribute, nie .open - ten sam wynik w przegladarce, a dziala tez w atrapach DOM z testow.
          if (details.hasAttribute('open')) syncMenuTop();
          else this.activate(this.tabs[0].dataset.gpTab);
          scheduleScrollLock();
        });
      }
    }

    disconnectedCallback() {
      // Sekcja przebudowana w edytorze motywu: menu znika razem z blokada.
      scheduleScrollLock();
    }

    activate(id, { focus = false } = {}) {
      if (!this.panels.has(id)) return;
      this.tabs.forEach((tab) => {
        const on = tab.dataset.gpTab === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) tab.focus();
      });
      this.panels.forEach((panel, key) => {
        if (key === id) panel.setAttribute('data-gp-active', '');
        else panel.removeAttribute('data-gp-active');
      });
      const active = this.panels.get(id);
      if (active && active.parentElement) active.parentElement.scrollTop = 0;
    }

    onKeydown(event, tab) {
      const i = this.tabs.indexOf(tab);
      let next = null;
      switch (event.key) {
        case 'ArrowDown': next = this.tabs[(i + 1) % this.tabs.length]; break;
        case 'ArrowUp': next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length]; break;
        case 'Home': next = this.tabs[0]; break;
        case 'End': next = this.tabs[this.tabs.length - 1]; break;
        case 'ArrowRight':
        case 'Enter':
        case ' ': {
          const link = this.panels.get(tab.dataset.gpTab)?.querySelector('a');
          if (link) { event.preventDefault(); link.focus(); }
          return;
        }
        default: return;
      }
      event.preventDefault();
      this.activate(next.dataset.gpTab, { focus: true });
    }
  }

  // Szuflada mobilna nie ma elementu <gp-car-menu>, wiec nasluch z connectedCallback jej nie obejmuje.
  // `toggle` nie babelkuje - lapiemy go w fazie przechwytywania, zeby klasa chowajaca widzety
  // zapalala sie tez przy otwarciu panelu w szufladzie.
  document.addEventListener('toggle', (event) => {
    if (event.target instanceof Element && event.target.matches('details.gp-car-menu--drawer')) scheduleScrollLock();
  }, true);

  if (!customElements.get('gp-car-menu')) customElements.define('gp-car-menu', GpCarMenu);
})();
